import AppointmentBooking from '@components/AppointmentBooking'
import styles from '@styles/BookingPage.module.css'
import SocialLinks from '@components/SocialLinks'
import Navbar from '@components/Navbar'

const BookingPage = () => {
  return (
    <div className={styles.bookingPage}>
      <Navbar className={styles.bookingNavbar} />
      <main className={styles.mainContent}>
        <div className={styles.detailContent}>
        <h1 className={styles.title}>Reserva tu Cita</h1>
        <p className={styles.description}>
          Selecciona la fecha y hora que mejor te convenga para tu próxima visita a nuestra óptica.
          Nuestro equipo de profesionales estará encantado de atenderte y ayudarte con todas tus necesidades visuales.
        </p>
        </div>
        <AppointmentBooking />
      </main>
      <footer className={styles.footer}>
        <SocialLinks />
      </footer>
    </div>
  )
}

export default BookingPage
